// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3OfGZ","clinicsSelect":"TableHeading_clinicsSelect__cmvTy"};